<template>
  <b-input
    v-model="innerValue"
    :name="placeholder"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :disabled="disabled"
    @blur="onBlur"
  />
</template>

<script>
export default {
  name: 'ModernTextInput',
  props: {
    value: {
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    maxlength: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    normalizeWhitespace(value) {
      return (value || '').trim().replace(/\s+/g, ' ');
    },
    onBlur() {
      this.$emit('input', this.normalizeWhitespace(this.innerValue));
    },
  },
};
</script>
